window.UYWishlist = (function () {
  var KEY = 'uy_wishlist';

  function get() {
    try {
      var raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function save(ids) {
    try {
      localStorage.setItem(KEY, JSON.stringify(ids));
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('uy-wishlist:change', { detail: { ids: ids } }));
  }

  function has(handle) {
    return get().indexOf(handle) !== -1;
  }

  function toggle(handle) {
    var ids = get();
    var idx = ids.indexOf(handle);
    if (idx === -1) {
      ids.push(handle);
    } else {
      ids.splice(idx, 1);
    }
    save(ids);
    return idx === -1;
  }

  function count() {
    return get().length;
  }

  return { get: get, has: has, toggle: toggle, count: count };
})();

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.uy-wishlist-btn').forEach(function (btn) {
    var handle = btn.getAttribute('data-wishlist-handle');
    if (!handle) return;
    if (UYWishlist.has(handle)) btn.classList.add('is-active');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var isNowActive = UYWishlist.toggle(handle);
      btn.classList.toggle('is-active', isNowActive);
    });
  });

  function updateBadge() {
    document.querySelectorAll('.uy-wishlist-count').forEach(function (el) {
      var n = UYWishlist.count();
      el.textContent = n > 0 ? n : '';
      el.style.display = n > 0 ? 'flex' : 'none';
    });
  }
  updateBadge();
  document.addEventListener('uy-wishlist:change', updateBadge);
});
